import { Injectable } from '@angular/core';

import { apiName } from "./data.service";
import { RestService } from "../../../core/services/rest.service";
import { GrupoMaterial } from "./grupo-material.model";

@Injectable()
export class GrupoMaterialApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: GrupoMaterial, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: GrupoMaterial, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":["codigo", "codigoGrupo"],"include":"contaContabil"};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetFather(fatherId: number, done: any) {
    this._restService.onGet(apiName + '/pai/' + fatherId, done);
  }

  onGetByCodeSubgrupo(code: string, fatherId: number, done: any) {
    var filter: any = {"where":{"codigoGrupo":code,"grupoId":fatherId}};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetByCodeGrupo(code: string, done: any) {
    var filter: any = {"where":{"codigo":code}};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    var filter: any = {"include":"contaContabil"};
    this._restService.onGetPostId(apiName, objectId, filter, done);
  }

  onGetGrupos(done: any) {
    var filter: any = {"where":{"ativo":true, "grupoId":null}};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetApiUrl() {
    return apiName;
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/grupos-materiais/shared/grupo-material-api.service.ts
 **/